import { supportHint } from "@/helpers/userMessages";

export const RECOVERY_BLOCKED_ROW_MESSAGE =
	"We don’t have all the data needed to finish this upload. Cancel it, then select the file again. If it’s in cloud storage, download it to this device first.";

export const RECOVERY_BLOCKED_TOAST_MESSAGE = (countLabel: string, count: number) =>
	`${countLabel} can't be recovered automatically. ${count === 1 ? "Cancel it and upload the file again." : "Cancel them and upload the files again."}`;

export const uploadStartRetryMessage = (subject: string) =>
	`We couldn't start ${subject}, so we'll keep trying automatically. ${supportHint()}`;
